declare var $;

import { Component, OnInit, ViewChild, ViewEncapsulation, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import 'rxjs/add/operator/filter';
import { state, style, transition, animate, trigger, AUTO_STYLE } from '@angular/animations';
import { JwtService } from "../../services/authentication/guards/jwt.service";
import { MenuItems } from '../../shared/menu-items/menu-items';
import { Router } from '@angular/router';
import { AppService } from '../../services/app-management/app-management';
import jwtDecode from 'jwt-decode';
import { AppSelectService } from '../../services/shared/appSelectService';
import { TranslateService } from '@ngx-translate/core/src/translate.service';
import { LoginService } from '../../services/authentication/login/login.service';
import { UserProfileImageService } from '../../services/shared/userProfileImageService';
import { UserService } from '../../services/user-management/user-management';
import { FormGroup, Validators, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
export interface Options {
  heading?: string;
  removeFooter?: boolean;
  mapHeader?: boolean;
}

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideOnOff', [
      state('on', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('off', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('on => off', animate('400ms ease-in-out')),
      transition('off => on', animate('400ms ease-in-out'))
    ]),
    trigger('mobileMenuTop', [
      state('no-block, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('yes-block',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('no-block <=> yes-block', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})

export class AdminLayoutComponent implements OnInit {


  isAppChange: boolean = false;
  selectedLanguage: string = sessionStorage.getItem('localeId') == 'en' ? 'English' : 'Swedish';
  isSwedish: boolean = sessionStorage.getItem('localeId') == 'en' ? false : true;
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  innerHeight: string;
  isScrolled = false;
  isCollapsedMobile = 'no-block';
  isCollapsedSideBar = 'no-block';
  toggleOn = true;
  windowWidth: number;
  myPlaceholderText: String = this.translate.instant('SELECTAPPFROMHERE');
  appList: Array<any> = [];
  selectAppId: String = this.jwtService.getApp().Id.toString();
  userProfileImage: string;
  public ModalAppId : number = 0;
  public ModalAppName : String;
  LayoutshowAggrementButton: boolean = false;
  LayoutAggrementForm;
  LayoutagreementText = '';
  form: FormGroup;

  snFestivalThemeFlag: number = 0;
  snowFlakes : any = [];

  token: any = this.jwtService.getDecodeToken();
  UserName: String = this.token.FirstName + ' ' + this.token.LastName;
  UserRole: String = ('UserRole_' + this.token.Role)
  @ViewChild('searchFriends') search_friends: ElementRef;
  @ViewChild('toggleButton') toggle_button: ElementRef;
  @ViewChild('sideMenu') side_menu: ElementRef;

  constructor(public menuItems: MenuItems, private jwtService: JwtService, private router: Router, private appService: AppService,
    private appSelectService: AppSelectService, private userProfileImageService: UserProfileImageService, private translate: TranslateService,
    private formBuilder: FormBuilder, private LoginService: LoginService, private userService: UserService) {
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
  }

  ngOnInit() {
    this.getFestivalTheme();
    this.getAppListByUserId();
    this.appSelectService.changeEmitted$.subscribe(
      (selectedAppId) => {
        this.selectAppId = selectedAppId;
      });

    this.userProfileImageService.changeEmitted$.subscribe(
      () => {
        this.UpdateUserProfileImage();
      });

    this.UpdateUserProfileImage();
    let IsAcceptEvent: boolean = false;
    this.LayoutAggrementForm = this.formBuilder.group({
      IsAcceptEvent: [IsAcceptEvent, Validators.compose([
        Validators.required
      ])]
      // Agreement: this.initPopupForm()

    });
  }


  UpdateUserProfileImage() {
    this.userService.getUserprofileimage().subscribe(
      data => {
        if (data.status === 200) {
          this.userProfileImage = data.json().data.PictureUrl;
          return true;
        }

        return false;
      },
      error => {
        if (error.status == 401 || error.status == 403) {
          this.jwtService.destroyToken();
          return this.router.navigateByUrl('/authentication/login');
        }
      }
    );
  }

  public setLanguage = (language) => {
    sessionStorage.setItem('localeId', language);
    location.reload();
  }

  onClickedOutside(e: Event) {

    if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
    //$('#OffMenu > li').removeClass('pcoded-trigger');

    $('.pcoded[vertical-nav-type="collapsed"] #OffMenu > li').removeClass('pcoded-trigger');


  }


  openSelectedApp() {

    var RoleId = this.jwtService.getDecodeToken().Role.toString();
    if (RoleId == '1') {
      if (this.menuItems != null) {
        this.menuItems.getAllVal();
        this.jwtService.saveApp(JSON.stringify({ Id: "0", Name: "" }));
        this.appSelectService.selectApp("0");
      }
      this.router.navigateByUrl("/dashboard/dashboard-default");
    
    // this.selectAppId = this.jwtService.getApp().Id.toString();
    // if (this.selectAppId == "0") {
    //   this.router.navigateByUrl("/dashboard/dashboard-default");
    // } 
    } else {
      this.appService.getListOfApp('0').subscribe(data => {
        if (data.status === 200) {
          if (data.json().data.length > 1) {
            this.menuItems.getAllVal();
            this.jwtService.saveApp(JSON.stringify({ Id: "0", Name: "" }));
            this.appSelectService.selectApp("0");
            this.router.navigateByUrl("/dashboard/dashboard-default");            
          }else{
            /*
            if (data.json().data.length > 1) {
              this.router.navigateByUrl("/dashboard/dashboard-default");
            }
            else { */
              this.selectAppId = this.jwtService.getApp().Id.toString();
              this.jwtService.saveApp(JSON.stringify({ Id: this.selectAppId, Name: this.jwtService.getApp().Name.toString() }));
              this.appSelectService.selectApp(this.selectAppId);
              this.router.navigateByUrl("/dashboard/dashboard-crm");
            //}
          }
          return true;
        }
      }, error => {

        if (error.status == 401 || error.status == 403) {

          this.jwtService.destroyToken();
          return this.router.navigateByUrl('/authentication/login');
        }

        this.router.navigateByUrl("/dashboard/dashboard-crm");
      });

      /*
      this.selectAppId = this.jwtService.getApp().Id.toString();
      this.jwtService.saveApp(JSON.stringify({ Id: this.selectAppId, Name: this.jwtService.getApp().Name.toString() }));
      this.appSelectService.selectApp(this.selectAppId);
      this.router.navigateByUrl("/dashboard/dashboard-default");
      //this.router.navigateByUrl("/dashboard/dashboard-crm");
      */
    }
  }


  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
      this.verticalNavType = 'collapsed';
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  setMenuAttributs(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.deviceType = 'tablet';
      this.verticalNavType = 'collapsed';
      this.verticalEffect = 'push';
    } else if (windowWidth < 768) {
      this.deviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.deviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  searchFriendList(event) {
    const search = (this.search_friends.nativeElement.value).toLowerCase();
    let search_input: string;
    let search_parent: any;
    const friendList = document.querySelectorAll('.userlist-box .media-body .chat-header');
    Array.prototype.forEach.call(friendList, function (elements, index) {
      search_input = (elements.innerHTML).toLowerCase();
      search_parent = (elements.parentNode).parentNode;
      if (search_input.indexOf(search) !== -1) {
        search_parent.classList.add('show');
        search_parent.classList.remove('hide');
      } else {
        search_parent.classList.add('hide');
        search_parent.classList.remove('show');
      }
    });
  }

  toggleOpened() {

    if (this.windowWidth < 768) {
      this.isCollapsedMobile = this.isCollapsedMobile = 'no-block';
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'collapsed' : 'expanded';
    }
  }
  toggleOpenedM() {

    if (this.windowWidth < 768) {
      $('body').toggleClass('hello');
      this.isCollapsedMobile = this.isCollapsedMobile = 'no-block';
    }
  }

  toggleOpenedSidebar() {
    this.isCollapsedSideBar = this.isCollapsedSideBar === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onMobileMenu() {

    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
    if (this.windowWidth < 768) {
      $('body').removeClass('hello');

    }
  }

  /*onclickhideuser(){
    this.isCollapsedMobile = this.isCollapsedMobile =  'no-block';
  }*/

  onLogout() {

    this.LoginService.logout().subscribe(
      data => {
        if (data.status === 200) {
          this.jwtService.destroyToken();
          this.router.navigateByUrl("/authentication/login");
          if (this.menuItems != null)
            this.menuItems.getAllVal();

          return true;
        }
        return false;
      },
      error => {
        if (error.status == 401 || error.status == 403) {
          this.jwtService.destroyToken();
          return this.router.navigateByUrl('/authentication/login');
        }
      }
    );
  }

  private cloneOptions(options: Array<IIdName>): Array<IOption> {
    return options.map(option => ({ value: option.Id, label: option.Name }));
  }
  onChange(event) {

    this.isAppChange = true;

  }

  onSelected(item) {    
    
    if (item != null) {
      
      this.appService.checkAgreement(parseInt(item.value), item.label).subscribe(
        data => {
          if (data.status === 200) {
            var response = JSON.parse(data.json().data);
            if(response[0].HasCMSDataProtectionAgreement == 0){
                this.ModalAppId = parseInt(item.value);
                this.ModalAppName = '';
                this.opendialog();  
                return false;
            }else{
              this.jwtService.saveApp(JSON.stringify({ Id: parseInt(item.value), Name: item.label }));
              this.appSelectService.selectApp(this.selectAppId);
              this.router.navigateByUrl("/dashboard/dashboard-crm");
              location.reload();  
              return true;
            }
                      
          }
          return false;
        },
        error => {
          if (error.status == 401 || error.status == 403) {
            this.jwtService.destroyToken();
            return this.router.navigateByUrl('/authentication/login');
          }
        }
      );
      /*

      //this.jwtService.saveApp(JSON.stringify({ Id: parseInt(item.value), Name: item.label }));
      //window.location.reload();
      this.jwtService.saveApp(JSON.stringify({ Id: parseInt(item.value), Name: item.label }));
      this.selectAppId = this.jwtService.getApp().Id.toString();
      this.appSelectService.selectApp(this.selectAppId);
      //this.router.navigateByUrl("/dashboard/dashboard-crm");
      location.reload(true);
      //window.location.reload();      

      */

    }

  }

  CloseMenu() {
    this.isCollapsedMobile = 'no-block';
    //document.querySelector('#pcoded').setAttribute('vertical-nav-type', 'collapsed');
    $('.pcoded[vertical-nav-type="collapsed"] #OffMenu > li').removeClass('pcoded-trigger');

    if (this.windowWidth < 1025) {
      $('.pcoded[vertical-nav-type="expanded"] #OffMenu > li').removeClass('pcoded-trigger');
      $('body').removeClass('hello');
    }
  }

  test() {
    //alert(this);
    // alert($("#OffMenu li a").html());
    // alert("uihj");
  }

  getAppListByUserId() {
    var tokenValue = this.jwtService.getToken();
    var getUserId = 0;
    if (typeof tokenValue !== 'undefined') {
      var decodedToken = jwtDecode(tokenValue);
      if (decodedToken && decodedToken.Id) {
        getUserId = decodedToken.Id;
        this.appService.getAppListByUserId(getUserId).subscribe(
          data => {
            if (data.status === 200) {

              this.appList = this.cloneOptions(data.json().data);
              return true;
            }
            return false;
          },
          error => {
            if (error.status == 401 || error.status == 403) {

              this.jwtService.destroyToken();
              return this.router.navigateByUrl('/authentication/login');
            }
          }
        );
      }
    }
  }

  opendialog = function () {
    this.LoginService.getInnerAgreement(this.ModalAppId).subscribe(
      data => {
        if (data.status === 200) {
          if (data.json().data) {
            this.agreementData = data.json().data;
            this.LayoutagreementText = this.agreementData.Agreement;            
            let element: HTMLElement = document.getElementById('LayoutagreementBtn') as HTMLElement;            
            element.click();
          } else {
            this.callNotification('AGGREMENT', this.translate.instant('AGREEMENTNOTFOUND'), 'error');
            return false;
          }
        }
        else {
          this.callNotification('AGGREMENT', this.translate.instant('SOMETHINGWENTWRONG'), 'error');
          return false;
        }
      },
      error => {

        if (error.status == 401 || error.status == 403) {

          this.jwtService.destroyToken();
          return this.router.navigateByUrl('/authentication/login');
        }

        this.callNotification('AGGREMENT', this.translate.instant('SOMETHINGWENTWRONG'), 'error');
        return false;
      }
    );
  }

  onAggrementOk = function () {
    //var token = this.jwtService.getDecodeToken();
    this.LoginService.updateInnerAgreement(this.agreementData.Id, this.ModalAppId).subscribe(
      data => {
        if (data.status === 200) {
            this.jwtService.saveApp(JSON.stringify({ Id: parseInt(this.ModalAppId), Name: this.ModalAppName }));
            //this.selectAppId = this.jwtService.getApp().Id.toString();
            this.appSelectService.selectApp(this.ModalAppId);
            this.router.navigateByUrl("/dashboard/dashboard-crm");
            let Closeelement: HTMLElement = document.getElementById('LayoutCloseModalBtn') as HTMLElement;            
            Closeelement.click();
            //location.reload(true);
            
        }
        else {
          return false;
        }

      },
      error => {
        if (error.status == 401 || error.status == 403) {

          this.jwtService.destroyToken();
          return this.router.navigateByUrl('/authentication/login');
        }

        return false;
      }
    );
  }

  onCloseModal = function (LayoutmodalAgreement) {
    LayoutmodalAgreement.hide();
  }

  getFestivalTheme(){
    let AppId = this.selectAppId;
    this.userService.getCMSFestivalTheme(AppId).subscribe((response: any) => {
      let FestivalType = JSON.parse(response._body).data.FestivalType;      
      if(FestivalType > 0){
        this.snFestivalThemeFlag = FestivalType;        
        let festivalClass = '';
        if(this.snFestivalThemeFlag == 1){
          festivalClass = 'christmasflake'  
        }else if(this.snFestivalThemeFlag == 2){
          festivalClass = 'easterflake'
        }else if(this.snFestivalThemeFlag == 3){
          festivalClass = 'midsummerflake'
        }else if(this.snFestivalThemeFlag == 4){
          festivalClass = 'swedishnationaldayflake'
        }else if(this.snFestivalThemeFlag == 5){
          festivalClass = 'valentineflake'
        }else if(this.snFestivalThemeFlag == 6){
          festivalClass = 'halloweenflake'  
        }else if(this.snFestivalThemeFlag == 7){
          festivalClass = 'newyeardayflake'
        }else if(this.snFestivalThemeFlag == 8){
          festivalClass = 'summerflake'  
        }else if(this.snFestivalThemeFlag == 9){
          festivalClass = 'summersunflake'  
        }else if(this.snFestivalThemeFlag == 10){
          festivalClass = 'springflake'
        }else if(this.snFestivalThemeFlag == 11){
          festivalClass = 'springflowerflake'  
        }else if(this.snFestivalThemeFlag == 12){
          festivalClass = 'autumnflake'  
        }else if(this.snFestivalThemeFlag == 13){
          festivalClass = 'autumnnutflake'  
        }else if(this.snFestivalThemeFlag == 14){
          festivalClass = 'winterflake'  
        }else if(this.snFestivalThemeFlag == 15){
          festivalClass = 'wintercloudflake'  
        }
        const snowContainer = document.getElementById('snow-container');
        if (snowContainer) {
          for (let i = 0; i < 25; i++) {
            const snowflake = document.createElement('div');
            //snowflake.className = 'snowflake';
            snowflake.className = festivalClass;
    
            // Randomize position and animation duration
            snowflake.style.left = Math.random() * 100 + 'vw';
            snowflake.style.animationDuration = Math.random() * 25 + 2 + 's'; // Between 2-5 seconds
            snowflake.style.opacity = (Math.random() + 0.5).toString();

            snowContainer.appendChild(snowflake);

            // Remove the snowflake after animation ends
            snowflake.addEventListener('animationend', () => {
              snowContainer.removeChild(snowflake);
            });
          }
        }
        
      }else{
        this.snFestivalThemeFlag = 0;
      }
    });
  }

}

export interface IOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface IIdName {
  Id: string;
  Name: string;
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/layouts/admin/admin-layout.component.ts